import { GridColumn, GridRow } from 'app/layouts/grid';
import React from 'react';
import { AlertSettings } from './alert';
import { Spacer } from 'app/layouts/generic';

export const GeneralSettings = () => {
  return (
    <>
      <Spacer multiple={4} />
      <GridRow num_of_columns={4}>
        <GridColumn>
          <AlertSettings />
        </GridColumn>
      </GridRow>
    </>
  );
};
